// extracted by mini-css-extract-plugin
export var contentFooter = "ContentFooter-module--content-footer--Y+KrA";